import { createContext, ReactNode, useMemo } from 'react';

// project imports
import config from 'config';
import { useLocalStorage } from 'hooks/useLocalStorage';

interface ConfigState {
  fontFamily: string;
  presetColor: string;
  [k: string]: unknown;
}

interface ConfigContextValue {
  state: ConfigState;
  setState: (next: ConfigState) => void;
  setField: (field: string, value: unknown) => void;
  resetState: () => void;
}

// ==============================|| CONFIG CONTEXT ||============================== //

export const ConfigContext = createContext<ConfigContextValue | undefined>(undefined);

// ==============================|| CONFIG PROVIDER ||============================== //

export function ConfigProvider({ children }: { children: ReactNode }) {
  const { state, setState, setField, resetState } = useLocalStorage('mantis-react-free-config', config) as unknown as ConfigContextValue;

  const memoizedValue = useMemo(() => ({ state, setState, setField, resetState }), [state, setField, setState, resetState]);

  return <ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>;
}
